/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homehelpwithtechnicalissuesheadline5Inputs */



/**
* | output |
* | --- |
* | "Help with Technical Issues" |
*
* @param {Homehelpwithtechnicalissuesheadline5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homehelpwithtechnicalissuesheadline5 = /** @type {((inputs?: Homehelpwithtechnicalissuesheadline5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homehelpwithtechnicalissuesheadline5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Help with Technical Issues")
	return /** @type {LocalizedString} */ ("Hast du technische Probleme?")
});
export { homehelpwithtechnicalissuesheadline5 as "homeHelpWithTechnicalIssuesHeadline" }